/**
 * Google Analytics, loaded only once somebody has said yes.
 *
 * Deliberately not a script tag in index.html: that version runs before the
 * visitor has been asked anything, which makes the consent banner decorative
 * and the privacy policy untrue.
 */

const measurementID = 'G-LLR4HEBD9Y'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let loaded = false

/** Injects the tag. Safe to call more than once; only the first call works. */
export function loadAnalytics(): void {
  if (loaded || typeof document === 'undefined') {
    return
  }
  loaded = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementID)
}

/**
 * Records a page view after a client-side navigation.
 *
 * The tag reports the page it loaded on and nothing after: every route change
 * here happens without a document load, so a single-page app that only calls
 * config sees one hit per visit however far somebody reads.
 */
export function trackPageView(path: string): void {
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  })
}
